"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        this.initialConfig = initialState ? initialState.map((row)=>[
                ...row
            ]) : null;
        if (initialState) this.grid = initialState.map((row)=>[
                ...row
            ]);
        else this.grid = Array(4).fill(null).map(()=>Array(4).fill(0));
        this.score = 0;
        this.status = "idle";
    }
    processRow(row) {
        let filteredRow = row.filter((num)=>num !== 0);
        for(let i = 0; i < filteredRow.length; i++)if (filteredRow[i] === filteredRow[i + 1]) {
            const newNum = filteredRow[i] *= 2;
            filteredRow[i + 1] = 0;
            this.score += newNum;
        }
        filteredRow = filteredRow.filter((n)=>n !== 0);
        while(filteredRow.length < 4)filteredRow.push(0);
        return filteredRow;
    }
    transpose() {
        const result = Array(4).fill(null).map(()=>Array(4).fill(0));
        for(let r = 0; r < this.grid.length; r++)for(let c = 0; c < this.grid[r].length; c++)result[c][r] = this.grid[r][c];
        this.grid = result;
    }
    canMove() {
        const flat = [
            ...this.grid
        ].flat();
        if (flat.includes(0)) return true;
        for(let r = 0; r < this.grid.length; r++)for(let c = 0; c < this.grid[r].length; c++){
            if (c < 3 && this.grid[r][c] === this.grid[r][c + 1]) return true;
            if (r < 3 && this.grid[r][c] === this.grid[r + 1][c]) return true;
        }
        return false;
    }
    afterMove(wasChanged) {
        if (this.grid.flat().includes(2048)) this.status = "win";
        if (wasChanged) this.addRandomTile();
        if (this.status === "playing" && !this.canMove()) this.status = "lose";
    }
    processFullGrid(reverseRows = false) {
        if (this.status !== "playing") return false;
        let wasChanged = false;
        for(let r = 0; r < this.grid.length; r++){
            const originRow = this.grid[r];
            const rowToProcess = reverseRows ? [
                ...originRow
            ].reverse() : originRow;
            const row = this.processRow(rowToProcess);
            if (reverseRows) row.reverse();
            if (row.join(",") !== originRow.join(",")) wasChanged = true;
            this.grid[r] = row;
        }
        return wasChanged;
    }
    moveLeft() {
        const changed = this.processFullGrid(false);
        this.afterMove(changed);
    }
    moveRight() {
        const changed = this.processFullGrid(true);
        this.afterMove(changed);
    }
    moveUp() {
        this.transpose();
        const changed = this.processFullGrid(false);
        this.transpose();
        this.afterMove(changed);
    }
    moveDown() {
        this.transpose();
        const changed = this.processFullGrid(true);
        this.transpose();
        this.afterMove(changed);
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.grid;
    }
    getStatus() {
        return this.status;
    }
    addRandomTile() {
        const emptyCells = [];
        for(let r = 0; r < this.grid.length; r++){
            for(let c = 0; c < this.grid[r].length; c++)if (this.grid[r][c] === 0) emptyCells.push({
                r: r,
                c: c
            });
        }
        if (emptyCells.length === 0) return 0;
        const randomIndex = Math.floor(Math.random() * emptyCells.length);
        const randomCell = emptyCells[randomIndex];
        const value = Math.random() < 0.1 ? 4 : 2;
        this.grid[randomCell.r][randomCell.c] = value;
    }
    start() {
        this.status = "playing";
        this.addRandomTile();
        this.addRandomTile();
    }
    restart() {
        this.score = 0;
        this.status = "idle";
        if (this.initialConfig) this.grid = this.initialConfig.map((row)=>[
                ...row
            ]);
        else this.grid = Array(4).fill(null).map(()=>Array(4).fill(0));
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$gameButton = document.querySelector(".start");
const $09e991522ca7e64e$var$field = document.querySelectorAll(".field-cell");
const $09e991522ca7e64e$var$score = document.querySelector(".game-score");
const $09e991522ca7e64e$var$winMessage = document.querySelector(".message-win");
const $09e991522ca7e64e$var$loseMessage = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$startMessage = document.querySelector(".message-start");
function $09e991522ca7e64e$var$render() {
    $09e991522ca7e64e$var$winMessage.classList.add("hidden");
    $09e991522ca7e64e$var$loseMessage.classList.add("hidden");
    const grid = $09e991522ca7e64e$var$game.getState().flat();
    for(let i = 0; i < grid.length; i++){
        $09e991522ca7e64e$var$field[i].textContent = grid[i] === 0 ? "" : grid[i];
        $09e991522ca7e64e$var$field[i].className = "field-cell";
        if ($09e991522ca7e64e$var$field[i] !== 0) $09e991522ca7e64e$var$field[i].classList.add("field-cell--" + grid[i]);
    }
    $09e991522ca7e64e$var$score.textContent = $09e991522ca7e64e$var$game.getScore();
    switch($09e991522ca7e64e$var$game.status){
        case "playing":
            $09e991522ca7e64e$var$gameButton.classList.remove("start");
            $09e991522ca7e64e$var$gameButton.classList.add("restart");
            $09e991522ca7e64e$var$gameButton.textContent = "Restart";
            break;
        case "win":
            $09e991522ca7e64e$var$winMessage.classList.remove("hidden");
            break;
        case "lose":
            $09e991522ca7e64e$var$loseMessage.classList.remove("hidden");
            break;
    }
}
$09e991522ca7e64e$var$gameButton.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$game.start();
    $09e991522ca7e64e$var$startMessage.classList.add("hidden");
    $09e991522ca7e64e$var$render();
});
window.addEventListener("keydown", (eventR)=>{
    if ($09e991522ca7e64e$var$game.status !== "playing") return;
    switch(eventR.key){
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            eventR.preventDefault();
            $09e991522ca7e64e$var$render();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            eventR.preventDefault();
            $09e991522ca7e64e$var$render();
            break;
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            eventR.preventDefault();
            $09e991522ca7e64e$var$render();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            eventR.preventDefault();
            $09e991522ca7e64e$var$render();
            break;
    }
});


//# sourceMappingURL=index.4ff59691.js.map
